import React from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import Img from "gatsby-image"

import { Grid } from "@material-ui/core"
import Typography from '../Typography'
import { makeStyles } from '@material-ui/core/styles'
import colors from '../../variables/colors'

const useStyles = makeStyles({
  section: {
    backgroundColor: colors.footer.bg,
  },
  button: {
    marginTop: '1rem'
  },
  main2: {
    padding: '20px 20px 0',
  },
  main: {
    padding: '12px',
  },
  mainText: {
    color: '#fff',
    padding: '0 8px'
  },
  siteLink: {
    color: '#fff',
    padding: '0 8px',
    lineHeight: 2
  },
  link : {
    textDecoration: 'none',
    color: 'inherit'
  },
  logoContainer: {
    maxWidth: '200px'
  },
  sitemapContainer: {
    margin: '30px auto 0 0'
  },
  certificateNumber: {
    color: '#fff',
    textAlign: 'center',
    maxWidth: '900px',
    fontSize: '0.9rem'
  },
  contactInfo: {
    maxWidth: '300px'
  },
  contactHeading: {
    marginTop: '10px',
    color: '#fff',
    padding: '0 8px'
  },
  copyright: {
    color: '#fff',
    padding: '0 0 0 105px'
  },
  developLink: {
    color: '#fff',
    textAlign: 'right'
  }
});

const Footer = (props) => {
  const classes = useStyles()
  const footer = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 120 ) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <React.Fragment>
      <section className={classes.section}>
        <Grid container className={classes.main2} justify="space-evenly">
          <Grid item md={4} className={classes.logoContainer}>
            <Img fixed={footer.logo.childImageSharp.fixed} className={classes.logo} />
          </Grid>
          <Grid item md={4} className={classes.sitemapContainer}>
            <Typography variant="h3" className={classes.mainText}>ಸತ್ಯಂಶಿವಂ ಸೇವಾ ಸಂಸ್ಥೆ</Typography>
            <Typography variant="body1" className={classes.siteLink}><Link to="/aboutUs"  className={classes.link}>ನಮ್ಮ ಬಗ್ಗೆ</Link></Typography>
            <Typography variant="body1" className={classes.siteLink}><Link to="/services"  className={classes.link}>ಸೇವೆಗಳು</Link></Typography>
            <Typography variant="body1" className={classes.siteLink}><Link to="/pictures"  className={classes.link}>ಚಿತ್ರ ಪಟಗಳು</Link></Typography>
            <Typography variant="body1" className={classes.siteLink}><Link to="/contactUs"  className={classes.link}>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</Link></Typography>
          </Grid>
          <Grid item md={4} className={classes.contactInfo}>
            <Typography variant="h6" className={classes.mainText}>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</Typography>
            <Typography variant="body1" className={classes.contactHeading}>ವಿಳಾಸ :</Typography>
            <Typography variant="subtitle1" className={classes.mainText}>ನಂ. 49/1,<br/>
              1ನೇ ಮಾಡಲ್ ಹೌಸ್ ಸ್ಟ್ರೀಟ್,<br />
              ಬಸವನಗುಡಿ, ಬೆಂಗಳೂರು
            </Typography>
            <Typography variant="body1" className={classes.contactHeading}>ಸಂಪರ್ಕ ಸಂಖ್ಯೆ :</Typography>
            <Typography variant="subtitle1" className={classes.mainText}>
              +91 98451 52307<br/>
              +91 78922 41605
            </Typography>
            <Typography variant="body1" className={classes.contactHeading}>ಇಮೇಲ್ : mandyasridhar537@gmail.com</Typography>
          </Grid>
        </Grid>
        <Typography variant="body1" className={classes.certificateNumber}>ನೋಂದಣಿ ಸಂಖ್ಯೆ: DRB2/SOR/31/2021-2022.&nbsp;&nbsp;&nbsp; ಪ್ರಮಾಣಪತ್ರ ಸಂಖ್ಯೆ: IN-KA26512961351183T</Typography>
        <Grid container className={classes.main} justify="space-between" alignItems="center">
          <Grid item md={4}>
            <Typography variant="subtitle1" className={classes.copyright}>Copyright © {(new Date()).getFullYear()} Satyam Shivam Seva</Typography>
          </Grid>
          <Grid item md={4}>
            <Typography variant="subtitle1" className={classes.developLink}><Link to="https://advaithdesignstudio.wordpress.com/" target="_blank" className={classes.link}>Website design and developed by Advaith Design Studio</Link></Typography>
          </Grid>
        </Grid>
      </section>
    </React.Fragment>
  )
}
export default Footer